/* SparkLo fixes (Oct 2026) */
(function () {
  'use strict';

  /* 1. Mobile menu: the theme's click handler on .parent-link calls preventDefault() for every
     link, so links without a sub-menu never opened. Handle them here (capture phase, runs first). */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('#wdt-mobile-menu a, #sticky-wdt-mobile-menu a, .wdt-mobile-menu a, .sticky-wdt-mobile-menu a');
    if (!a) return;
    var li = a.closest('li');
    if (li && li.querySelector('.child-menu')) return;
    var href = a.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = href;
  }, true);

  /* 2. On phones the header icons (account / search / cart) are hidden by CSS and offered inside
     the hamburger menu instead. */
  function addExtras() {
    var navs = document.querySelectorAll('#wdt-mobile-menu > ul, #sticky-wdt-mobile-menu > ul, .wdt-mobile-menu > ul, .sticky-wdt-mobile-menu > ul');
    var seen = [];
    navs.forEach(function (ul) {
      if (seen.indexOf(ul) > -1 || ul.querySelector('.sl-mob-extra')) return;
      seen.push(ul);
      var items = [
        ['Search', '/search', 'sl-search'],
        ['My Account', '/account', 'sl-account'],
        ['Cart', '/cart', 'sl-cart']
      ];
      items.forEach(function (it, i) {
        var li = document.createElement('li');
        li.className = 'sl-mob-extra' + (i === 0 ? ' sl-first' : '');
        var a = document.createElement('a');
        a.className = 'parent-link ' + it[2];
        a.setAttribute('href', it[1]);
        a.textContent = it[0];
        li.appendChild(a);
        ul.appendChild(li);
      });
    });
    if (!seen.length) return;
    try {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (c && c.item_count > 0) {
          document.querySelectorAll('.sl-cart').forEach(function (a) { a.textContent = 'Cart (' + c.item_count + ')'; });
        }
      }).catch(function () {});
    } catch (err) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addExtras);
  else addExtras();
})();
